import { gql } from "@apollo/client";

export const TOGGLE_CHAT_PRIVACY = gql`
    mutation ToggleChatPrivacy($id: ID!, $isPrivate: Boolean) {
        toggleChatPrivacy(id: $id, isPrivate: $isPrivate) {
            id
            isPrivate
        }
    }
`; 